import { render, staticRenderFns } from "./remnantOrder4.vue?vue&type=template&id=0b0533dc&scoped=true&"
import script from "./remnantOrder4.vue?vue&type=script&lang=js&"
export * from "./remnantOrder4.vue?vue&type=script&lang=js&"
import style0 from "./remnantOrder4.vue?vue&type=style&index=0&id=0b0533dc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0533dc",
  null
  
)

export default component.exports